import React from 'react';
import {observer} from 'mobx-react';
import {ProgressIndicator} from 'components';
import {FormattedMessage} from 'react-intl';

const GoalItem = observer(({model}) => {
  const goal = model;

  return (
    <div className='clearfix mxn2'>
      <div className='col col-12 px2 pb1'>
        <span className='h3 medium black'>{goal.title}</span>
      </div>
      <div className='col col-12 px2 pb1'>
        <div className='table-cell jumbo pr1'>
          {`${goal.completeness}%`}
        </div>
        <div className='table-cell full-width'>
          <ProgressIndicator items={goal.progressBarItems} />
        </div>
      </div>
      <div className='col col-12 px2'>
        <div className='clearfix h5'>
          <div className='col col-4'>
            <span className='medium'>
              <FormattedMessage id='goals.Start Date:'/>
            </span>
            <span className='jumbo'>
              {goal.startDateView}
            </span>
          </div>
          <div className='col col-4'>
            <span className='medium'>
              <FormattedMessage id='goals.End Date:'/>
            </span>
            <span className='jumbo'>
              {goal.endDateView}
            </span>
          </div>
          <div className='col col-4'>
            <span className='medium'>
              <FormattedMessage id='goals.Progress Updates:'/>
            </span>
            <span className='jumbo'>
              {goal.progressUpdates.length}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
});

export default GoalItem;
